import { render, staticRenderFns } from "./Aftersaleslistcomplete.vue?vue&type=template&id=5b421970&"
import script from "./Aftersaleslistcomplete.vue?vue&type=script&lang=js&"
export * from "./Aftersaleslistcomplete.vue?vue&type=script&lang=js&"
import style0 from "./Aftersaleslistcomplete.vue?vue&type=style&index=0&id=5b421970&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b421970')) {
      api.createRecord('5b421970', component.options)
    } else {
      api.reload('5b421970', component.options)
    }
    module.hot.accept("./Aftersaleslistcomplete.vue?vue&type=template&id=5b421970&", function () {
      api.rerender('5b421970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Aftersaleslistcomplete.vue"
export default component.exports